<template>
  <div class="preview-bar">
    <div class="preview-total">
      <span class="preview-label">{{ $tc("calculateView.previewBar.text", 0) }}</span>
      <span class="preview-cost">{{ totalCost }}</span>
    </div>
    <div class="preview-per-month">
      <span class="preview-label">{{ $tc("calculateView.previewBar.text", 1) }}</span>
      <span class="preview-cost">{{ perMonthCost }}</span>
    </div>
    <div class="preview-additional-info">
      {{ $tc("calculateView.previewBar.text", 2) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "PreviewBar",
  props: ["totalCost", "perMonthCost"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.preview-bar {
  position: sticky;
  bottom: 0;
  box-shadow: 0px 0px 4px rgba(112, 112, 112, 0.6);
  background-color: var(--primary-lightgray);
  padding: 12px 15px;
  font-size: 12px;

  @media (min-width: $small) {
    font-size: 13px;
  }

  @media (min-width: $medium) {
    padding: 30px;
    font-size: 16px;
  }
  @media (min-width: 1400px) {
    font-size: 18px;
  }

  .preview-total {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    color: var(--sale-price);

    .preview-label {
      font-family: var(--font-default);
      font-weight: 500;
      font-size: 1.2em;
    }

    .preview-cost {
      font-family: var(--font-brand);
      font-weight: 700;
      font-size: 1.8em;
    }
  }

  .preview-per-month {
    margin-top: 6px;
    display: flex;
    justify-content: flex-end;
    color: var(--primary-darkgreen);
    font-family: var(--font-default);
    font-size: 1em;

    @media (min-width: 1400px) {
      margin-top: 10px;
    }

    .preview-label {
      font-weight: 500;
    }

    .preview-cost {
      font-weight: 600;
      padding-left: 0.25em;
    }
  }

  .preview-additional-info {
    margin-top: 5px;
    text-align: right;
    color: var(--primary-black);
    font-family: var(--font-default);
    font-size: 0.95em;

    @media (min-width: $medium) {
      margin-top: 10px;
    }

    @media (min-width: $large) {
      font-size: 0.8em;
    }
  }
}
</style>
